









































import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { EditorHelper } from '../helpers';

export default defineComponent({
  name: 'SlideShowBottomBar',
  props: {
    blockWidth: { type: Object as PropType<Record<string, boolean>>, default: () => ({}) },
    isGridView: { type: Boolean },
    isLightboxView: { type: Boolean },
    currentSlide: { type: Number, default: 0 },
    slides: { type: Number, default: 1 },
    gridSlides: { type: Number, default: 1 },
    isSticky: { type: Boolean },
    blockWidthClass: { type: String, default: '' },
    route: { type: Object, default: () => ({}) },
  },
  setup(props) {
    const numOfSlides = computed(() => {
      if (props.isGridView) {
        return props.gridSlides;
      }
      return props.slides;
    });

    return {
      numOfSlides,
      isBlockWidthSmall: EditorHelper.isBlockWidthSmall,
    };
  },
});
